// Cross-domain URLs used by the marketing site to link into the app
// subdomain. Defaults match prod; override via VITE_APP_BASE_URL for
// local dev or staging.
const APP_BASE_URL =
  import.meta.env.VITE_APP_BASE_URL ?? "https://app.tapelens.com";

export const SIGNIN_URL = `${APP_BASE_URL}/auth/signin`;
export const SIGNUP_URL = `${APP_BASE_URL}/auth/signup`;

export function signupUrlForPlan(plan: "free" | "pro" | "analyst"): string {
  return `${SIGNUP_URL}?plan=${plan}`;
}
